import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {errorInterceptorProvider} from "./errors.interceptor";
import {AppAuthModule} from '../../app-auth/app-auth.module';
import {HttpWrapper} from "./http.wrapper";




@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    errorInterceptorProvider,
    HttpWrapper
  ],
})
export class HttpHelpersModule { }
